import { render, staticRenderFns } from "./PosizioneQrCode.vue?vue&type=template&id=3b21eee1"
import script from "./PosizioneQrCode.vue?vue&type=script&lang=js"
export * from "./PosizioneQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports